<ng-container *ngIf="vm$ | async as vm">
<div class="od-toolbar">
  <label class="od-select"><span>Sobre qué:</span>
    <select aria-label="Sobre qué" [value]="filtro.sobre" (change)="elegirSobre($any($event.target).value)">
      <option *ngFor="let s of sobres; trackBy: porValor" [value]="s.valor" [selected]="filtro.sobre === s.valor">{{ s.texto }}</option>
    </select>
  </label>
  <label class="od-select"><span>Resultado:</span>
    <select aria-label="Resultado" [value]="filtro.ok" (change)="elegirResultado($any($event.target).value)">
      <option *ngFor="let r of resultados; trackBy: porValor" [value]="r.valor" [selected]="filtro.ok === r.valor">{{ r.texto }}</option>
    </select>
  </label>
  <label class="od-input" style="width: 220px">
    <od-icon name="search"></od-icon>
    <input type="search" [formControl]="buscar" placeholder="Buscar por nombre" aria-label="Buscar por nombre" maxlength="60">
  </label>
  <button type="button" class="od-btn od-btn-sm" (click)="recargar()" title="Volver a consultar" aria-label="Volver a consultar">
    <od-icon name="refresh"></od-icon>
  </button>
  <span class="od-fin" *ngIf="vm.hayDatos">{{ vm.total }} {{ vm.total === 1 ? 'movimiento' : 'movimientos' }} · {{ vm.conProblema }} con problema</span>
</div>

  <div class="od-alert" *ngIf="vm.error" role="alert">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx">
      <b>No se pudo traer la bitácora</b>
      <p class="od-muted">{{ vm.error }}</p>
    </div>
    <button type="button" class="od-btn od-btn-sm" (click)="recargar()">Reintentar</button>
  </div>

  <div aria-busy="true" *ngIf="vm.cargando && !vm.hayDatos && !vm.error">
    <div class="od-skeleton" style="height: 44px; margin-bottom: 8px" *ngFor="let i of esperando; trackBy: porIndice"></div>
  </div>

  <ng-container *ngIf="vm.hayDatos">
    <div class="od-empty" *ngIf="!vm.grupos.length">
      <od-icon name="history" [size]="22"></od-icon>
      <b>No hay movimientos con ese filtro</b>
      <span>Todo lo que se le avisa a Odoo queda anotado aquí durante 180 días.</span>
    </div>

    <section *ngFor="let g of vm.grupos; trackBy: porGrupo" [attr.aria-label]="g.titulo">
      <p class="od-grp">{{ g.titulo }}</p>
      <ng-container *ngFor="let m of g.items; trackBy: porId">
        <div [class.od-open]="abierto === m._id">
          <div class="od-ev" role="button" tabindex="0" style="cursor: pointer" [attr.aria-expanded]="abierto === m._id"
               [style.border]="abierto === m._id ? '0' : null" [style.padding]="abierto === m._id ? '0 0 6px' : null"
               (click)="alternar(m._id)" (keydown.enter)="alternar(m._id)" (keydown.space)="$event.preventDefault(); alternar(m._id)">
            <span class="od-ev-tx">
              <b>{{ m.frase }}</b>
              <span class="od-muted" *ngIf="m.nota"> {{ m.nota }}</span>
              <span class="od-muted"> · {{ m.quien }}</span>
            </span>
            <span class="od-ev-tm">{{ hora(m.createdAt) }}</span>
            <span class="od-badge od-badge-solid" *ngIf="m.ok"><od-icon name="check" [size]="12"></od-icon>Bien</span>
            <span class="od-badge od-badge-problem" *ngIf="!m.ok"><od-icon name="alert" [size]="12"></od-icon>Con problema</span>
          </div>

          <ng-container *ngIf="abierto === m._id">
            <p><b>En palabras simples:</b> {{ m.simple }}</p>
            <p style="margin-top: 4px" *ngIf="m.motivo"><b>Motivo:</b> <span class="od-muted">{{ m.motivo }}</span></p>
            <p style="margin-top: 4px"><b>Lo que contestó Odoo:</b> <span class="od-muted">{{ respuestaSimple(m) }}</span></p>
            <p style="margin-top: 4px"><b>Cuánto tardó:</b> <span class="od-muted">{{ duracion(m.duracion_ms) }}</span>
              · <b>Quién:</b> <span class="od-muted">{{ m.quien }}</span></p>
            <div style="margin-top: 8px">
              <button type="button" class="od-btn od-btn-sm" (click)="alternarTecnico(m._id)" [attr.aria-expanded]="tecnicoAbierto.has(m._id)">
                Ver datos técnicos
                <od-icon name="chev" [size]="12"></od-icon>
              </button>
            </div>
            <ng-container *ngIf="tecnicoAbierto.has(m._id)">
              <div class="od-skeleton" style="height: 60px; margin-top: 8px" *ngIf="tecnicos[m._id]?.cargando" aria-busy="true"></div>
              <p class="od-muted" style="margin-top: 8px" *ngIf="tecnicos[m._id]?.error">{{ tecnicos[m._id]?.error }}</p>
              <ng-container *ngIf="tecnicos[m._id]?.datos as t">
                <p class="od-soft" style="margin-top: 8px; font-size: 12px">LO QUE SE ENVIÓ</p>
                <pre class="od-mono" style="margin: 2px 0 0; padding: 8px; background: #fff; border: 1px solid var(--od-line); border-radius: 6px; max-height: 240px; overflow: auto; font-size: 12px; white-space: pre-wrap">{{ t.peticion ? (t.peticion | json) : 'Nada: no llegó a enviarse.' }}</pre>
                <p class="od-soft" style="margin-top: 8px; font-size: 12px">LO QUE RESPONDIÓ ODOO</p>
                <pre class="od-mono" style="margin: 2px 0 0; padding: 8px; background: #fff; border: 1px solid var(--od-line); border-radius: 6px; max-height: 240px; overflow: auto; font-size: 12px; white-space: pre-wrap">{{ t.respuesta ? (t.respuesta | json) : (t.error || 'Sin respuesta.') }}</pre>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </section>

    <div class="od-toolbar" style="margin-top: 12px" *ngIf="vm.total > limite">
      <button type="button" class="od-btn od-btn-sm" [disabled]="filtro.page <= 1 || vm.cargando" (click)="cambiar({ page: filtro.page - 1 })">Anterior</button>
      <span class="od-muted">Página {{ filtro.page }} de {{ totalPaginas(vm.total) }}</span>
      <button type="button" class="od-btn od-btn-sm" [disabled]="filtro.page >= totalPaginas(vm.total) || vm.cargando" (click)="cambiar({ page: filtro.page + 1 })">Siguiente</button>
    </div>
  </ng-container>
</ng-container>
